import Heading from "Components/Heading";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Form } from "react-bootstrap";
import { BiExport } from "react-icons/bi";
import Footer from "Components/Footer";
import Loader from "Components/Loader";
import SearchForm from "Components/SearchForm";
import { toast } from "react-toastify";
import MapBox from "Components/MapBox";
import { formatDate } from "Helper/Converters";
import { exportFileToExcel, priorityColors } from "Utils/utils";

const SearchTicketByMap = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchedData, setSearchedData] = useState([]);

  // Map related state
  const [mapLocations, setMapLocations] = useState([]);
  const [isPolygonEnabled, setIsPolygonEnabled] = useState(false);

  // Build map markers whenever search results change
  useEffect(() => {
    const locations =
      searchedData
        ?.map((item, index) => {
          const lat = parseFloat(item?.lat);
          const lng = parseFloat(item?.lng);

          // skip invalid coords
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

          return {
            id: index,
            ticketId: item?.id,
            ticketNo: item?.ticketNo,
            label: `
              <b>Ticket No:</b> ${item?.ticketNo || ""}<br>
              <b>Contractor Name:</b> ${item?.contractor_name || ""}<br>
              <b>Company Name:</b> ${item?.company_name || ""}<br>
              <b>Ticket Type:</b> ${item?.priority || ""}<br>
              <b>Dig Address:</b> ${item?.digAddress || ""}<br>
              <button class="btn btn-primary mt-2" onclick="window.open('/dashboard/ticket-detail/${
                item?.ticketNo
              }')">View Ticket</button>
            `,
            lat,
            lng,
            color: priorityColors?.[item?.priority] || priorityColors?.default,
          };
        })
        .filter(Boolean) || [];

    setMapLocations(locations);
  }, [searchedData]);

  const formatDateForExcel = () => {
    let formattedData = [
      [
        { v: "Ticket #", t: "s" },
        { v: "Address", t: "s" },
        { v: "Contractor", t: "s" },
        { v: "Type of Ticket", t: "s" },
        { v: "Entered Date", t: "s" },
        { v: "Assigned Date", t: "s" },
        { v: "Assigned To", t: "s" },
        { v: "Due Date", t: "s" },
        { v: "Completed Date", t: "s" },
        { v: "Station Code", t: "s" },
        { v: "Segment", t: "s" },
        { v: "Office Clear", t: "s" },
        { v: "Locate City", t: "s" },
        { v: "Caller Name", t: "s" },
        { v: "Type of Work", t: "s" },
        { v: "Per-Ticket", t: "s" },
      ],
    ];

    searchedData.forEach((item) => {
      formattedData.push([
        { v: item.ticketNo },
        { v: `${item.digAddress}\n${item.region}\n${item.priority}` },
        { v: `${item.company_name} ${item.contractor_name} ${item.region}` },
        { v: item.priority },
        { v: item.entered ? formatDate(item.entered) : "" },
        { v: item.assign || "" },
        {
          v: item.assigntoo
            ? `${item.assigntoo.firstName} ${item.assigntoo.lastName}`
            : "",
        },
        { v: item.dueDate ? formatDate(item.dueDate) : "" },
        { v: item.completedDate ? formatDate(item.completedDate) : "" },
        { v: item.code?.map((c) => c.name).join(", ") || "" },
        { v: item.segmet || "" },
        { v: item.isOfficeClear ? "Yes" : "No" },
        { v: item.region || "" },
        { v: item.contractor_name || "" },
        { v: item.ticketType || "" },
        { v: item.isAssignPerTicket ? "Yes" : "No" },
      ]);
    });

    return formattedData;
  };

  const exportToExcel = () => {
    if (!(searchedData.length > 0)) {
      toast.error("No data found yet!");
      return;
    }
    const data = formatDateForExcel();
    exportFileToExcel(data, "Searched_Tickets");
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}

      <section>
        <Heading text={"Query/Search Ticket (Map)"} btn />

        <Card>
          <SearchForm
            setSearchedData={setSearchedData}
            setIsLoading={setIsLoading}
            loadDataOnMount={false}
          />

          <Row
            className="d-flex justify-content-end mb-3"
            style={{ marginTop: "-62px" }}
          >
            <Col md={3} className={"d-flex justify-content-end mb-3"}>
              <Button onClick={exportToExcel}>
                <BiExport />
                Export
              </Button>
            </Col>
          </Row>

          {/* Optional: polygon toggle*/}
          {/* <Row className="mb-2">
            <Col md={12}>
              <Form.Check
                type="checkbox"
                id="Polygon Select"
                label="Polygon Select"
                checked={isPolygonEnabled}
                onChange={() => setIsPolygonEnabled((p) => !p)}
                className="include-check"
              />
            </Col>
          </Row> */}

          {/*  Map replaces the table */}
          <MapBox
            locations={mapLocations}
            onSelectedLocations={() => {}}
            enablePolygon={isPolygonEnabled}
            enableTicketDetail={false}
            mapContainerStyle={{
              height: "560px",
              width: "100%",
              borderRadius: "10px",
            }}
          />

          <Footer />
        </Card>
      </section>
    </>
  );
};

export default SearchTicketByMap;